module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/user-folder-3756cb082237a536cbdc6443476a6e86.svg";